import styled from 'styled-components';
import refresh from '~/assets/icons/refresh.svg';

const StyledContainer = styled.div`
	position: absolute;
	top: 140px;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1px 1fr;
	padding: 0 40px 0 60px;
	transition: opacity 0.3s ease;
`;

const StyledIcon = styled.img.attrs({ src: refresh })`
	margin: 0 40px 0 30px;
	opacity: 0.1;
	user-select: none;
	pointer-events: none;
`;

const StyledDivider = styled.div`
	width: 1px;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.1);
`;

export { StyledContainer, StyledIcon, StyledDivider };
